import * as React from 'react';

import { Search } from "../Search/Search";
import { Fundpages } from "../FundPages/Fundpages";
import { Filtersidebar } from "../Filtersidebar/Filtersidebar";
import { HistoricalPricesModal } from "../HistoricalPricesModal/HistoricalPricesModal";
import { IExplorerProperties } from "../../models";
import { isNullOrUndefined, addItemToGoogleTracking } from "../../utils";
import { StickyContainer, Sticky } from 'react-sticky';

const styles = require('./FundExplorerPage.pcss');
// tslint:disable-next-line:variable-name
const FaAngleLeft = require('react-icons/lib/fa/angle-left');
const searchBarStyles = require('./overrides/mainSearch.pcss');

interface IState {
	isOpen?: boolean;
	width?: number;
	targetTouches?: any;
	passive?: any;
}

export class FundExplorerPage extends React.Component<IExplorerProperties, IState>{
	fetchingData = false;
	constructor(props) {
		super(props);

		this.toggleLeftPane = this.toggleLeftPane.bind(this);
		this.state = {
			isOpen: true,
			passive: false,
		};
	}

	updateLocalState() {
		this.setState({ width: window.innerWidth });
	}

	componentWillMount() {
		this.updateLocalState();
	}

	toggleLeftPane(event) {
		event.preventDefault();
		let { appParams } = this.props;
		let { isOpen } = this.state;
		this.setState({ isOpen: !isOpen });
		if (isOpen) {
			addItemToGoogleTracking(appParams, "scroll_filter_fundpage", { eventLabel: "Close", eventCategory: "Close advanced filter" });
		}
		else {
			addItemToGoogleTracking(appParams, "scroll_filter_fundpage", { eventLabel: "Open", eventCategory: "Open advanced filter" });
		}

		let menu = document.querySelector("html");
		menu.classList.toggle('noscroll');

	}

	render() {

		let { filterOptions, changeFilter, filter, isLoading, appParams, typeahead, sorting, modals, toggleModal } = this.props;
		let { isOpen, width } = this.state;
		if (isNullOrUndefined(typeahead)) {
			return null;
		}
		let activeState = this.state.isOpen ? '' : styles.flipped;
		let activeState2 = this.state.isOpen ? '' : styles.noScroll;

		let internalClasses = {
			reveal: isOpen ? styles.show : styles.hide,
			active: `${styles.menutoggle} ${activeState}`,
			noscroll: `${styles.scrollable} ${activeState2}`,
		};

		if (width < 1196) {
			{/* console.log('width is less that 1196'); sets the default for whether the sidebar is exposed or not */ }
			internalClasses = {
				reveal: isOpen ? styles.hide : styles.show,
				active: `${styles.menutoggle} ${activeState}`,
				noscroll: `${styles.scrollable} ${activeState2}`,
			};
		}

		if (width < 733) {
			return (
				<div className={`${styles.wrapper} ${internalClasses.reveal}`}>
					<div><HistoricalPricesModal modals={modals} toggleModal={toggleModal} appParams={appParams} sorting={sorting} /></div>
					<div className={styles.sidebar_wrapper}>
						<Filtersidebar {...this.props} />
					</div>

					<StickyContainer className={styles.stickyMobile}>
						<Sticky className={styles.stickyActive}>
							<span id="menuToggle" onClick={this.toggleLeftPane} className={internalClasses.active}>
								<span className={styles.filterName}>
									Filter <FaAngleLeft />
								</span>
							</span>
						</Sticky>
					</StickyContainer>

					<div id="codehouse" className={styles.page_contentwrapper + ' ' + `${internalClasses.noscroll}`}>
						<div className={styles.pageLayout}>
							<Search
								isLoading={isLoading}
								filterOptions={filterOptions}
								changeFilter={changeFilter}
								appParams={appParams}
								filter={filter}
								typeahead={typeahead}
								styles={searchBarStyles} />
							<Fundpages {...this.props} />
						</div>
					</div>
				</div>
			);
		}

		else {
			return (
				<div className={`${styles.wrapper} ${internalClasses.reveal}`}>
					<div><HistoricalPricesModal modals={modals} toggleModal={toggleModal} appParams={appParams} sorting={sorting} /></div>
					<StickyContainer className={styles.stickyContainer}>
						<Sticky className={styles.stickyActive}>
							<div className={styles.sidebar_wrapper}>
								<Filtersidebar {...this.props} />
							</div>
						</Sticky>
					</StickyContainer>

					<StickyContainer>
						<Sticky className={styles.stickyActive}>
							<span id="menuToggle" onClick={this.toggleLeftPane} className={internalClasses.active}>
								<span className={styles.filterName}>
									Filter <FaAngleLeft />
								</span>
							</span>
						</Sticky>
					</StickyContainer>

					<div id="codehouse" className={styles.page_contentwrapper}>
						<div className={styles.pageLayout}>
							<Search
								isLoading={isLoading}
								filterOptions={filterOptions}
								changeFilter={changeFilter}
								appParams={appParams}
								filter={filter}
								typeahead={typeahead}
								styles={searchBarStyles} />
							<Fundpages {...this.props} />
						</div>
					</div>
				</div>
			);
		}

	}
}




// WEBPACK FOOTER //
// ./src/client/components/FundExplorerPage/FundExplorerPage.tsx